import { useState, useEffect } from "react";
import localforage from "localforage";

/**
 * useLocalStorage hook
 * #core #context
 * This hook uses localforage to store and retrieve data from the user's local storage.
 * It takes a key and an optional initialValue as arguments.
 * If the key is not found in local storage, it sets the value to initialValue.
 * It returns an array with two elements: the value stored in local storage and a function to set the value.
 * 
 * @param {string} key - the key to store the data in local storage
 * @param {*} initialValue - the initial value to set if the key is not found in local storage
 * @returns {array} - an array with two elements: the value stored in local storage and a function to set the value
 */
const useLocalStorage = (key, initialValue) => {
  localforage.config({
    name: 'GssMega',
    isPersistent: true
});
 
  const [value, setValue] = useState();
  useEffect(()=>{
    const getData = async() => {
      localforage.getItem(key).then(item=>{
        if(item){setValue(item)}
        if(initialValue)setValue(initialValue)

    })}
    getData()
  },[])

  const setLocalValue = (value) => {
    try {
      //window.localStorage.setItem(key, JSON.stringify(value));
      localforage?.setItem(key, value)?.then(setValue(value))
      
    } catch (error) {
      alert("Something went wrong with setting localforage, see console");
      console.log(error);   
    }
  }

  return [value, setLocalValue];
}

export default useLocalStorage;

/* const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      if(item){return JSON.parse(item)}
      if(initialValue) return initialValue
      return undefined;
    } catch (error) {
      //alert("Something went wrong.");
      //console.log(`errore ${key} `,error);    
    }
  });

  const setLocalValue = (value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      setValue(value)
    } catch (error) {
      //alert("Something went wrong.");
      //console.log(error);   
    }
  }

  return [value, setLocalValue];
} */
